module.exports = __webpack_public_path__ + "img/69.7e7d2084.svg";